import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import filterFactory, { selectFilter, textFilter } from "react-bootstrap-table2-filter";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, FormGroup, Col, Row, Badge, Card, CardBody } from "reactstrap";
import Switch from "react-switch"
import Swal from "sweetalert2";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import axios from "axios";
import Select from "react-select";
import * as urls from "helpers/url_helper"; // assuming urls are here
import { useReassignCustomerMutation, useBulkUpdateReportDataMutation } from "store/enptReport/enptReport.api";
import jwt from "jsonwebtoken";

import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";

const baseUrl = process.env.LOCALHOST ? process.env.LOCALHOST : "https://qa_api_gtc.amerck.com";

const cleanSmscDate = (val) => {
  if (!val) return "";
  return val.toString().trim()
    .replace('T', ' ')
    .replace(/\.\d+Z$/, '')
    .replace(/Z$/, '')
    .replace(/\s*\+\s*0(:00)?$/, '');
};

const EnptReportDataGrid = ({ reportData, selectedDate, setLoading, refetchReport, refetchRows, refetchList, customers, reportCustomer, initialHighlights, reportId }) => {
  const [data, setData] = useState([]);
  const [editedRows, setEditedRows] = useState({});
  const [highlights, setHighlights] = useState([]);

  const decodeToken = token => {
    try {
      return jwt.decode(token);
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

  const token = localStorage.getItem("authUser");
  const decodedToken = token ? decodeToken(JSON.parse(token)) : null;
  const role = decodedToken?.role ;

  useEffect(() => {
    if (initialHighlights) {
      setHighlights(initialHighlights);
    }
  }, [initialHighlights]);

  const addHighlight = (cellKey) => {
    console.log(`[HIGHLIGHT] Trying to ADD highlight for: ${cellKey}`);
    setHighlights(prev => {
      if (!prev.find(h => h.highlight_data === cellKey)) {
        console.log(`[HIGHLIGHT] Added! State will be updated.`);
        return [...prev, { highlight_data: cellKey }];
      }
      console.log(`[HIGHLIGHT] Already exists in state.`);
      return prev;
    });
  };

  const removeHighlight = (cellKey) => {
    console.log(`[HIGHLIGHT] Trying to REMOVE highlight for: ${cellKey}`);
    setHighlights(prev => {
      const newArr = prev.filter(h => h.highlight_data !== cellKey);
      console.log(`[HIGHLIGHT] Removed! Old size: ${prev.length}, New size: ${newArr.length}`);
      return newArr;
    });
  };

  // Mutations
  const [reassignCustomer] = useReassignCustomerMutation();
  const [bulkUpdateReportData] = useBulkUpdateReportDataMutation();

  const [showHiddenColumns, setShowHiddenColumns] = useState(true);

  const toggleHiddenColumns = () => {
    setShowHiddenColumns(!showHiddenColumns);
  };

  // Reassignment State
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [newCustomer, setNewCustomer] = useState(null);

  // Bulk Update State
  const [showBulkPanel, setShowBulkPanel] = useState(false);
  const [bulkField, setBulkField] = useState("enterprise");
  const [bulkFind, setBulkFind] = useState("");
  const [bulkReplace, setBulkReplace] = useState("");
  const [searchResults, setSearchResults] = useState(null);

  const currentHighlightsKeys = highlights.map(h => h.highlight_data).sort().join(',');
  const initialHighlightsKeys = (initialHighlights || []).map(h => h.highlight_data).sort().join(',');
  const isHighlightsChanged = currentHighlightsKeys !== initialHighlightsKeys;

  const isOldReport = React.useMemo(() => {
    if (!reportData || reportData.length === 0) return false;
    return reportData.some(r => r.sender_recieved && r.cat_bypass == null && r.cat_other_channel == null && r.cat_simbox_onnet == null);
  }, [reportData]);

  const cellFormatter = (cell, row, columnName, customLogic) => {
    const rowId = row.id || row.uid;
    const cellKey = `${rowId}-${columnName}`;

    const isHighlighted = highlights?.map(obj => obj.highlight_data).includes(cellKey);
    
    // Evaluate custom logic first to see if it provides any children or styling
    let renderedCell = customLogic ? customLogic(cell, row) : cell;
    
    // Use state-based highlights
    const backgroundColor = isHighlighted ? "yellow" : "";

    return (
      <div
        style={{ height: "100%", minHeight: "50px", backgroundColor }}
        id={`cell-div-${rowId}-${columnName}`}
      >
        {[2, 3, 5].includes(role) ? (
          <>
            <ContextMenuTrigger
              id={`menu-${rowId}-${columnName}`}
              collect={() => [rowId, columnName]}
              className={`cell-trigger-${rowId}-${columnName}`}
              style={{ height: "100%", display: "block" }}
            >
              <div style={{ height: "100%", padding: "5px" }}>
                 {renderedCell}
              </div>
            </ContextMenuTrigger>
            <ContextMenu
              id={`menu-${rowId}-${columnName}`}
              className="custom-context-menu"
            >
              <MenuItem
                onClick={() => {
                  console.log(`[MENU] Clicked Highlight for ${cellKey}. isHighlighted was: ${isHighlighted}`);
                  const el = document.getElementById(`cell-div-${rowId}-${columnName}`);
                  if (el) {
                    console.log(`[MENU] DOM element found, forcing yellow`);
                    el.style.backgroundColor = "yellow";
                  } else {
                    console.warn(`[MENU] DOM element cell-div-${rowId}-${columnName} NOT found!`);
                  }
                  addHighlight(cellKey);
                }}
              >
                Highlight
              </MenuItem>
              <MenuItem
                onClick={() => {
                  console.log(`[MENU] Clicked Un-Highlight for ${cellKey}. isHighlighted was: ${isHighlighted}`);
                  const el = document.getElementById(`cell-div-${rowId}-${columnName}`);
                  if (el) {
                    console.log(`[MENU] DOM element found, forcing white`);
                    el.style.backgroundColor = "";
                  } else {
                    console.warn(`[MENU] DOM element cell-div-${rowId}-${columnName} NOT found!`);
                  }
                  removeHighlight(cellKey);
                }}
              >
                Un-Highlight
              </MenuItem>
              {!isOldReport && (
                <MenuItem
                  onClick={() => {
                    const el = document.getElementById(`cell-div-${rowId}-${columnName}`);
                    if (el) {
                      const tdElement = el.closest('td');
                      if (tdElement) {
                        tdElement.dispatchEvent(new MouseEvent('dblclick', { bubbles: true }));
                      }
                    }
                  }}
                >
                  Edit cell
                </MenuItem>
              )}
            </ContextMenu>
          </>
        ) : (
          <div style={{ height: "100%", padding: "5px" }}>
             {renderedCell}
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (reportData) {
      // Data arrives pre-filtered by test_date from the backend paginated endpoint.
      // Just make a mutable copy for the cell editor and assign a unique internal key 'uid'
      const mutableData = reportData.map(item => {
        let newItem = { 
          ...item, 
          smsc_date: cleanSmscDate(item.smsc_date),
          uid: `uid_${item.id || Date.now()}_${Math.random()}` 
        };
        return newItem;
      });
      setData(mutableData);
    }
  }, [reportData]);

  const cellEdit = React.useMemo(() => cellEditFactory({
    mode: "dbclick",
    blurToSave: true,
    afterSaveCell: (oldValue, newValue, row, column) => {
      if (column.dataField === "id" && newValue) {
        // Prevent duplicate ID entry
        const exists = data.some(r => r.id && r.id.toString() === newValue.toString() && r.uid !== row.uid);
        if (exists) {
          Swal.fire("Error", "Existing ID can't be added", "error");
          
          // Force the ID to auto-clear to blank (null string)
          const revertedRow = { ...row, id: "" };
          setData(prevData => prevData.map(r => r.uid === row.uid ? revertedRow : r));
          setEditedRows(prev => ({ ...prev, [row.uid]: revertedRow }));
          return;
        }
      }

      if (oldValue !== newValue) {
        let finalRow = { ...row };

        setEditedRows((prev) => {
          const updated = {
            ...prev,
            [finalRow.uid]: finalRow,
          };
          console.log("Current editedRows state:", updated);
          return updated;
        });
      } else {
        console.log("Value unchanged, skipping save to editedRows.");
      }
    },
  }), [data]);

  const handleSaveChanges = async () => {
    const updatedRowsArray = Object.values(editedRows);
    
    console.log("[SAVE] Current Highlights:", currentHighlightsKeys);
    console.log("[SAVE] Initial Highlights:", initialHighlightsKeys);
    console.log("[SAVE] Highlights Changed?", isHighlightsChanged);
    console.log("[SAVE] Edited Rows Count:", updatedRowsArray.length);

    if (updatedRowsArray.length === 0 && !isHighlightsChanged) {
      console.log("[SAVE] Aborting save. No edits and no highlight changes.");
      Swal.fire("Info", "No changes detected.", "info");
      return;
    }

    try {
      setLoading(true);
      
      // The updateReport API requires the report ID, reportData, kpis, edrs, reportInfo
      // We are only updating reportData rows here, so we could send the full updated reportData array
      // For simplicity, we assume we just need to pass the updated reportData array.
      // The API requires the specific report ID. We assume all rows belong to the same report.
      // We use the reportId passed down as a prop
      if (!reportId) {
        Swal.fire("Error", "Missing report ID. Cannot save.", "error");
        return;
      }
      
      // Only send the rows that were actually edited
      const changedRowsData = updatedRowsArray.map((row) => {
        const { uid, ...rest } = row;
        
        // If ID was left blank or is "Pending", completely remove it so the DB auto-increments
        if (!rest.id || rest.id === "" || rest.id === "Pending") {
          delete rest.id;
        }
        
        return rest;
      });

      const token = JSON.parse(localStorage.getItem("authUser"));
      
      const payload = {
        highlights: highlights
      };

      if (changedRowsData.length > 0) {
        payload.reportData = changedRowsData;
      }

      console.log("[SAVE] Sending payload to API:", payload);

      const hasEnterpriseEdit = changedRowsData.some(r => {
        if (!r.enterprise || r.enterprise.toString().trim() === '') return false;
        if (r.isNew || !r.id) return true;
        const originalRow = (reportData || []).find(o => o.id === r.id);
        return !originalRow || originalRow.enterprise !== r.enterprise;
      });

      // Show loading popup if enterprise is being edited/validated
      if (hasEnterpriseEdit) {
        Swal.fire({
          title: "Saving Changes...",
          text: "Validating enterprises & updating report data...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
      }

      const url = urls.UPDATE_ENPT_REPORT ? `${urls.UPDATE_ENPT_REPORT}/${reportId}` : `${baseUrl}/enpt/updateReport/${reportId}`;

      const response = await axios.put(url, payload, {
        headers: {
          auth: token,
        },
      });

      if (response.data && response.data.isValidationError) {
        const warnings = response.data.warnings || {};
        const { unallowedEnterprises = [], allowedEnterprisesId, standardRenamesId } = warnings;
        const allowedLink = `https://docs.google.com/spreadsheets/d/${allowedEnterprisesId}/edit`;
        const renamesLink = `https://docs.google.com/spreadsheets/d/${standardRenamesId}/edit`;

        Swal.fire({
          icon: "warning",
          title: "Unrecognized Enterprises Found",
          width: "600px",
          html: `
            <p style="font-size: 15px; margin-bottom: 15px;">
              The changes <b>were NOT saved</b> because these enterprise names are unrecognized:
            </p>
            <div style="max-height: 180px; overflow-y: auto; text-align: left; background: #f8f9fa; border: 1px solid #e9ecef; padding: 12px; border-radius: 6px; margin-bottom: 20px;">
              <ul style="margin: 0; padding-left: 20px; color: #d9534f; font-weight: 500;">
                ${unallowedEnterprises.map(ent => `<li style="margin-bottom: 4px;">${ent}</li>`).join("")}
              </ul>
            </div>
            <p style="font-size: 14px; color: #6c757d; margin-bottom: 15px;">
              Please update the respective Google Sheet, then try saving again.
            </p>
            <div style="display: flex; justify-content: center; gap: 15px; margin-top: 10px;">
              <a href="${allowedLink}" target="_blank" class="btn px-4 py-2 shadow-sm" style="background-color: #dc3741; color: white; border: none; text-decoration: none; border-radius: 4px;"><i class="fas fa-plus-circle me-1"></i> Add New Brand</a>
              <a href="${renamesLink}" target="_blank" class="btn px-4 py-2 shadow-sm" style="background-color: #dc3741; color: white; border: none; text-decoration: none; border-radius: 4px;"><i class="fas fa-edit me-1"></i> Fix Misspelled Brand</a>
            </div>
          `,
          showConfirmButton: false,
          showCloseButton: true
        });
        return;
      }

      if (response.data && response.data.success === false) {
        if (hasEnterpriseEdit) Swal.close();
        Swal.fire("Validation Error", response.data.message || "Failed to validate enterprise with Google Sheets.", "error");
        return;
      }

      if (hasEnterpriseEdit) {
        Swal.close();
      }

      toastr.success("Values Updated", "Edit Successful");
      setEditedRows({});
      if (refetchReport) refetchReport();
      if (refetchRows) refetchRows();
    } catch (error) {
      console.error("Error saving changes:", error);
      const errMsg = error.response?.data?.error || error.response?.data?.message || error.message;
      Swal.fire("Error", `Failed to save changes: ${errMsg}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteRecord = async (row) => {
    try {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      });

      if (result.isConfirmed) {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("authUser"));
        // Depending on routing setup, use standard URL construction
        const url = urls.DELETE_ENPT_REPORT_RECORD 
          ? `${urls.DELETE_ENPT_REPORT_RECORD}/${row.id}` 
          : `${baseUrl}/enpt/reportDataRecord/${row.id}`;
        
        await axios.delete(url, {
          headers: {
            auth: token,
          },
        });

        Swal.fire(
          'Deleted!',
          'Record has been deleted.',
          'success'
        );
        
        if (refetchRows) refetchRows();
        if (refetchReport) refetchReport();
      }
    } catch (error) {
      console.error("Error deleting record:", error);
      Swal.fire("Error", "Failed to delete record.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleAddRow = () => {
    const reportId = data.length > 0 ? data[0].report_id : reportData?.[0]?.report_id;
    if (!reportId) {
      Swal.fire("Error", "Cannot determine Report ID", "error");
      return;
    }

    const baseDate = selectedDate || (data.length > 0 ? data[0].test_date : "") || (data.length > 0 && data[0].smsc_date ? data[0].smsc_date.substring(0, 10) : "");

    const newUid = `temp_${Date.now()}`;
    const newRow = {
      uid: newUid,
      id: "Pending", // Set to "Pending" so user knows DB will generate it safely
      report_id: reportId,
      test_date: baseDate,
      country: data.length > 0 ? data[0].country : "",
      operator: data.length > 0 ? data[0].operator : "",
      receiver: data.length > 0 ? data[0].receiver : "",
      smsc_date: baseDate ? `${baseDate} 11:11:11` : "",
      enterprise: "",
      sender_recieved: "",
      enterprise_recognizable: "",
      recieved_text: "",
      smsc: "",
      smsc_owner: "",
      expected_sms: "",
      is_delivered: "yes",
      isNew: true
    };

    // Add to local data at the top
    setData([newRow, ...data]);

    // Add to editedRows immediately so it can be saved even if untouched
    setEditedRows((prev) => ({
      ...prev,
      [newUid]: newRow
    }));
  };

  const handleReassignCustomer = async () => {
    if (!newCustomer) {
      Swal.fire("Error", "Please select a new customer", "error");
      return;
    }
    const reportId = data.length > 0 ? data[0].report_id : reportData?.[0]?.report_id;
    if (!reportId) return;

    try {
      const result = await Swal.fire({
        title: 'Reassign Customer?',
        text: `This will update the customer for this entire report to ${newCustomer.label}. Continue?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, reassign!'
      });

      if (result.isConfirmed) {
        setLoading(true);
        await reassignCustomer({ id: reportId, newCustomer: newCustomer.label }).unwrap();
        Swal.fire('Success!', 'Customer has been reassigned.', 'success');
        setShowReassignModal(false);
        if (refetchReport) refetchReport();
        if (refetchRows) refetchRows();
        if (refetchList) refetchList(); // ← refresh the list table so Report Name updates immediately
      }
    } catch (error) {
      console.error("Error reassigning customer:", error);
      const errMsg = error.data?.error || error.message;
      Swal.fire("Error", `Failed to reassign customer: ${errMsg}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchBulk = () => {
    if (bulkFind !== "" && bulkFind.length < 3) return;
    const searchTerm = bulkFind.toLowerCase();
    const matches = data.filter(row => {
      const cellValue = row[bulkField];
      if (bulkFind === "") {
        return cellValue == null || cellValue === "";
      }
      if (cellValue == null) return false;
      return cellValue.toString().toLowerCase().includes(searchTerm);
    });
    setSearchResults(matches);
  };

  const handleClearSearch = () => {
    setSearchResults(null);
    setBulkFind("");
    setBulkReplace("");
  };

  const handleBulkUpdate = async () => {
    if (bulkReplace === undefined || bulkReplace === null) {
      Swal.fire("Error", "Please enter a replace value", "error");
      return;
    }
    const reportId = data.length > 0 ? data[0].report_id : reportData?.[0]?.report_id;
    if (!reportId) return;

    try {
      const result = await Swal.fire({
        title: 'Perform Bulk Update?',
        text: `This will update ${searchResults.length} records in the database. You cannot revert this!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, update them!'
      });

      if (result.isConfirmed) {
        setLoading(true);
        if (bulkField === 'enterprise') {
          Swal.fire({
            title: "Updating Enterprises...",
            text: "Validating against Google Sheets...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        }
        const finalReplaceValue = bulkReplace === "null" ? null : bulkReplace;
        const res = await bulkUpdateReportData({ 
          id: reportId, 
          field: bulkField, 
          findValue: bulkFind, 
          replaceValue: finalReplaceValue 
        }).unwrap();
        
        if (res && res.isValidationError) {
          const warnings = res.warnings || {};
          const { unallowedEnterprises = [], allowedEnterprisesId, standardRenamesId } = warnings;
          const allowedLink = `https://docs.google.com/spreadsheets/d/${allowedEnterprisesId}/edit`;
          const renamesLink = `https://docs.google.com/spreadsheets/d/${standardRenamesId}/edit`;

          Swal.fire({
            icon: "warning",
            title: "Unrecognized Enterprises Found",
            width: "600px",
            html: `
              <p style="font-size: 15px; margin-bottom: 15px;">
                The update <b>was NOT applied</b> because this enterprise name is unrecognized:
              </p>
              <div style="max-height: 180px; overflow-y: auto; text-align: left; background: #f8f9fa; border: 1px solid #e9ecef; padding: 12px; border-radius: 6px; margin-bottom: 20px;">
                <ul style="margin: 0; padding-left: 20px; color: #d9534f; font-weight: 500;">
                  ${unallowedEnterprises.map(ent => `<li style="margin-bottom: 4px;">${ent}</li>`).join("")}
                </ul>
              </div>
              <p style="font-size: 14px; color: #6c757d; margin-bottom: 15px;">
                Please update the respective Google Sheet, then try updating again.
              </p>
              <div style="display: flex; justify-content: center; gap: 15px; margin-top: 10px;">
                <a href="${allowedLink}" target="_blank" class="btn px-4 py-2 shadow-sm" style="background-color: #dc3741; color: white; border: none; text-decoration: none; border-radius: 4px;"><i class="fas fa-plus-circle me-1"></i> Add New Brand</a>
                <a href="${renamesLink}" target="_blank" class="btn px-4 py-2 shadow-sm" style="background-color: #dc3741; color: white; border: none; text-decoration: none; border-radius: 4px;"><i class="fas fa-edit me-1"></i> Fix Misspelled Brand</a>
              </div>
            `,
            showConfirmButton: false,
            showCloseButton: true
          });
          return;
        }

        if (res && res.success === false) {
          if (bulkField === 'enterprise') Swal.close();
          Swal.fire("Validation Error", res.message || "Failed to validate enterprise with Google Sheets.", "error");
          return;
        }

        if (bulkField === 'enterprise') {
          Swal.close();
        }

        Swal.fire('Success!', `Bulk update completed. ${res.updatedRows} rows updated.`, 'success');
        handleClearSearch();
        if (refetchReport) refetchReport();
        if (refetchRows) refetchRows();
      }
    } catch (error) {
      console.error("Error performing bulk update:", error);
      const errMsg = error.data?.error || error.message;
      Swal.fire("Error", `Failed to bulk update: ${errMsg}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const currentCustomerName = reportCustomer || "Unknown";


  const OTT_CHANNELS = ['WhatsApp', 'Telegram', 'Viber', 'RCS', 'TextToSpeech', 'FlashCall'];



  const filterOptions = React.useMemo(() => {
    const options = {
      enterprise_recognizable: {},
      smsc: {},
      smsc_owner: {},
      expected_sms: {},
      is_delivered: {}
    };

    if (data && data.length > 0) {
      data.forEach(row => {
        if (row.enterprise_recognizable !== null && row.enterprise_recognizable !== undefined) {
          options.enterprise_recognizable[row.enterprise_recognizable] = row.enterprise_recognizable;
        }
        if (row.smsc !== null && row.smsc !== undefined) {
          options.smsc[row.smsc] = row.smsc;
        }
        if (row.smsc_owner !== null && row.smsc_owner !== undefined) {
          options.smsc_owner[row.smsc_owner] = row.smsc_owner;
        }
        if (row.expected_sms !== null && row.expected_sms !== undefined) {
          options.expected_sms[row.expected_sms] = row.expected_sms;
        }
        if (row.is_delivered !== null && row.is_delivered !== undefined) {
          options.is_delivered[row.is_delivered] = row.is_delivered;
        }
      });
    }

    const sortObject = (obj) => {
      return Object.keys(obj)
        .sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' }))
        .reduce((acc, key) => {
          acc[key] = obj[key];
          return acc;
        }, {});
    };

    options.smsc = sortObject(options.smsc);
    options.smsc_owner = sortObject(options.smsc_owner);

    return options;
  }, [data]);

  const columns = React.useMemo(() => [
    { dataField: "id", text: "ID", style: { minWidth: "80px" }, editable: (cell, row) => !!row.isNew },
    { dataField: "country", text: "Country", style: { minWidth: "100px" }, formatter: (cell, row) => cellFormatter(cell, row, "country") },
    { dataField: "operator", text: "Operator", style: { minWidth: "120px" }, formatter: (cell, row) => cellFormatter(cell, row, "operator") },
    { dataField: "receiver", text: "Receiver", style: { minWidth: "150px" }, formatter: (cell, row) => cellFormatter(cell, row, "receiver") },
    { 
      dataField: "smsc_date", 
      text: "Att/Del Date ", 
      style: { minWidth: "160px" },
      sort: true,
      defaultSortDirection: 'asc',
      sortCaret: (order, column) => {
        if (!order) return <i className="bx bx-sort text-muted ms-2" style={{ fontSize: '16px' }}></i>;
        else if (order === 'asc') return <i className="bx bx-sort-up text-danger ms-2 fw-bold" style={{ fontSize: '18px' }}></i>;
        else if (order === 'desc') return <i className="bx bx-sort-down text-danger ms-2 fw-bold" style={{ fontSize: '18px' }}></i>;
        return null;
      },
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        // Always pin new rows to the top
        if (rowA.isNew && !rowB.isNew) return -1;
        if (!rowA.isNew && rowB.isNew) return 1;

        let valA = cleanSmscDate(a);
        let valB = cleanSmscDate(b);
        
        if (order === 'asc') {
          return valA > valB ? 1 : (valA < valB ? -1 : 0);
        } else {
          return valA < valB ? 1 : (valA > valB ? -1 : 0);
        }
      },
      formatter: (cell, row) => cellFormatter(cell, row, "smsc_date", (c) => {
        const clean = cleanSmscDate(c);
        return clean ? clean + "+0" : "";
      })
    },
    { 
      dataField: "enterprise", 
      text: "Enterprise", 
      style: { minWidth: "150px" }, 
      sort: true,
      sortCaret: (order, column) => {
        if (!order) return <i className="bx bx-sort text-muted ms-2" style={{ fontSize: '16px' }}></i>;
        else if (order === 'asc') return <i className="bx bx-sort-up text-danger ms-2 fw-bold" style={{ fontSize: '18px' }}></i>;
        else if (order === 'desc') return <i className="bx bx-sort-down text-danger ms-2 fw-bold" style={{ fontSize: '18px' }}></i>;
        return null;
      },
      filter: textFilter(),
      formatter: (cell, row) => cellFormatter(cell, row, "enterprise")
    },
    { 
      dataField: "sender_recieved", 
      text: "Sender Received", 
      style: { minWidth: "150px" }, 
      filter: textFilter(),
      formatter: (cell, row) => cellFormatter(cell, row, "sender_recieved")
    },
    { 
      dataField: "enterprise_recognizable", 
      text: "Recognizable", 
      style: { minWidth: "100px" },
      filter: selectFilter({
        options: { ...filterOptions.enterprise_recognizable, all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          if (filterVal === "Empty") return tableData.filter(row => !row.enterprise_recognizable);
          return tableData.filter(row => row.enterprise_recognizable === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "enterprise_recognizable")
    },
    { dataField: "recieved_text", text: "Received Text", style: { minWidth: "200px" }, headerStyle: { textAlign: "center" }, filter: textFilter(), formatter: (cell, row) => cellFormatter(cell, row, "recieved_text") },
    { 
      dataField: "smsc", 
      text: "SMSC", 
      style: { minWidth: "150px" }, 
      filter: selectFilter({
        options: { ...filterOptions.smsc, all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          if (filterVal === "Empty") return tableData.filter(row => !row.smsc);
          return tableData.filter(row => row.smsc === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "smsc")
    },
    { 
      dataField: "smsc_owner", 
      text: "SMSC Owner", 
      style: { minWidth: "150px" },
      filter: selectFilter({
        options: { ...filterOptions.smsc_owner, all: "All", Empty: "Empty" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          if (filterVal === "Empty") return tableData.filter(row => !row.smsc_owner);
          return tableData.filter(row => row.smsc_owner === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "smsc_owner")
    },
    { 
      dataField: "expected_sms", 
      text: "Expected SMSC", 
      style: { minWidth: "120px" },
      filter: selectFilter({
        options: { ...filterOptions.expected_sms, all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          if (filterVal === "Empty") return tableData.filter(row => !row.expected_sms);
          return tableData.filter(row => row.expected_sms === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "expected_sms")
    },
    {
      dataField: "is_delivered",
      text: "Is Delivered",
      style: { minWidth: "100px" },
      filter: selectFilter({
        options: { ...filterOptions.is_delivered, all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          if (filterVal === "Empty") return tableData.filter(row => !row.is_delivered);
          return tableData.filter(row => row.is_delivered === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "is_delivered"),
      editor: {
        type: 'select',
        options: [{
          value: 'yes',
          label: 'Yes'
        }, {
          value: 'no',
          label: 'No'
        }]
      }
    },
    {
      dataField: "template_spoofing",
      text: " Template Spoofing ",
      style: { minWidth: "150px" },
      filter: selectFilter({
        options: { yes: "yes", no: "no", all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          return tableData.filter(row => row.template_spoofing === filterVal);
        }
        // add tempalte spoofing to the filter options
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "template_spoofing"),
      editor: {
        type: 'select',
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }]
      }
    },
    {
      dataField: "cat_other_channel",
      text: "Other Channel Delivery",
      style: { minWidth: "150px" },
      filter: selectFilter({
        options: { yes: "yes", no: "no", all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          return tableData.filter(row => row.cat_other_channel === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "cat_other_channel"),
      editor: {
        type: 'select',
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }]
      }
    },
    {
      dataField: "cat_simbox_onnet",
      text: "SIM box & on-net Delivery",
      style: { minWidth: "150px" },
      filter: selectFilter({
        options: { yes: "yes", no: "no", all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          return tableData.filter(row => row.cat_simbox_onnet === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "cat_simbox_onnet"),
      editor: {
        type: 'select',
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }]
      }
    },
    {
      dataField: "cat_simbox_onnet_nonoff",
      text: "no SIM box & on-net non-official Delivery",
      style: { minWidth: "150px" },
      filter: selectFilter({
        options: { yes: "yes", no: "no", all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          return tableData.filter(row => row.cat_simbox_onnet_nonoff === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "cat_simbox_onnet_nonoff"),
      editor: {
        type: 'select',
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }]
      }
    },
    {
      dataField: "cat_simbox_natoffnet",
      text: "SIM box & national off-net Delivery",
      style: { minWidth: "150px" },
      filter: selectFilter({
        options: { yes: "yes", no: "no", all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          return tableData.filter(row => row.cat_simbox_natoffnet === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "cat_simbox_natoffnet"),
      editor: {
        type: 'select',
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }]
      }
    },
    {
      dataField: "cat_nosimbox_natoffnet",
      text: "no SIM box & national off-net Delivery",
      style: { minWidth: "150px" },
      filter: selectFilter({
        options: { yes: "yes", no: "no", all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          return tableData.filter(row => row.cat_nosimbox_natoffnet === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "cat_nosimbox_natoffnet"),
      editor: {
        type: 'select',
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }]
      }
    },
    {
      dataField: "cat_international",
      text: "International Delivery",
      style: { minWidth: "150px" },
      filter: selectFilter({
        options: { yes: "yes", no: "no", all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          return tableData.filter(row => row.cat_international === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "cat_international"),
      editor: {
        type: 'select',
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }]
      }
    },
    {
      dataField: "cat_bypass",
      text: "Bypass Delivery",
      style: { minWidth: "150px" },
      filter: selectFilter({
        options: { yes: "yes", no: "no", all: "All" },
        defaultValue: "all",
        withoutEmptyOption: true,
        onFilter: (filterVal, tableData) => {
          if (filterVal === "all") return tableData;
          return tableData.filter(row => row.cat_bypass === filterVal);
        }
      }),
      formatter: (cell, row) => cellFormatter(cell, row, "cat_bypass"),
      editor: {
        type: 'select',
        options: [{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }]
      }
    },
    {
      dataField: "actions",
      text: "Actions",
      isDummyField: true,
      editable: false,
      hidden: isOldReport || ![3, 5].includes(role),
      style: { minWidth: "80px", textAlign: "center" },
      formatter: (cell, row) => (
        <Button 
          color="danger" 
          size="sm" 
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteRecord(row);
          }}
          title="Delete Record"
          style={{ padding: "0.25rem 0.5rem" }}
        >
          <i className="bx bx-trash font-size-16 align-middle"></i>
        </Button>
      )
    }
  ], [filterOptions, highlights, isOldReport, role]);

  const visibleColumns = showHiddenColumns
    ? columns.filter(
        column =>
          ![
            "id",
            "country",
            "operator",
            "receiver",
          ].includes(column.dataField)
      )
    : columns;

  return (
    <div className="table-responsive">
      <style>
        {`
          .react-bootstrap-table th {
            background-color: #f3f4f6 !important;
            color: #495057 !important;
            vertical-align: middle;
          }
        `}
      </style>
      
      {/* Customer Info Bar */}
      <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light rounded shadow-sm border text-dark">
        <div className="d-flex align-items-center gap-2">
          <span className="fw-bold text-dark">Current Customer:</span>
          <span className="fw-bold text-dark font-size-15">{currentCustomerName}</span>
        </div>
        {[3, 5].includes(role) && (
          <Button color="danger" outline onClick={() => setShowReassignModal(true)}>
            <i className="bx bx-transfer align-middle me-1"></i> Reassign Customer
          </Button>
        )}
      </div>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center gap-2">
          <label style={{ marginBottom: 0 }}>Hide Columns : &nbsp;</label>
          <Switch
            onChange={toggleHiddenColumns}
            checked={showHiddenColumns}
            id="columnToggle"
            onColor="#8e292b"
            offColor="#717273"
            checkedIcon={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  fontSize: 7,
                  color: "white",
                  paddingLeft: 2,
                }}
              >
                Hidden
              </div>
            }
            uncheckedIcon={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  fontSize: 7,
                  color: "white",
                  paddingRight: 2,
                }}
              >
                Visible
              </div>
            }
            width={45}
            height={18}
          />
        </div>
        <div className="legend d-flex gap-3 align-items-center flex-wrap">
          {/* <div className="d-flex align-items-center gap-1">
            <span style={{ display: 'inline-block', width: '15px', height: '15px', backgroundColor: '#ff4d4d', border: '1px solid #cc0000' }}></span>
            <span style={{ fontSize: '0.85em', fontWeight: 'bold' }}>Not Delivered</span>
          </div>
          <div className="d-flex align-items-center gap-1">
            <span style={{ display: 'inline-block', width: '15px', height: '15px', backgroundColor: '#ffa500', border: '1px solid #cc8400' }}></span>
            <span style={{ fontSize: '0.85em', fontWeight: 'bold' }}>Unrecognizable</span>
          </div>
          <div className="d-flex align-items-center gap-1">
            <span style={{ display: 'inline-block', width: '15px', height: '15px', backgroundColor: '#ffff00', border: '1px solid #cccc00' }}></span>
            <span style={{ fontSize: '0.85em', fontWeight: 'bold' }}>Off-route</span>
          </div>
          <div className="d-flex align-items-center gap-1">
            <span style={{ display: 'inline-block', width: '15px', height: '15px', backgroundColor: '#d288ff', border: '1px solid #aa00ff' }}></span>
            <span style={{ fontSize: '0.85em', fontWeight: 'bold' }}>OTT Channel</span>
          </div> */}
        </div>
        <div className="d-flex gap-2">
          {isOldReport ? (
            <Badge color="warning" className="p-2 font-size-13">
              Historical Report (Read-Only)
            </Badge>
          ) : (
            <>
              {[3, 5].includes(role) && (
                <>
                  <Button 
                    color="danger" 
                    outline
                    onClick={() => window.open('https://docs.google.com/spreadsheets/d/1fh4yQXTLoJkf3fhIl3OO9Dx1bkYoeHLuA-21PvOwDMY', '_blank')}
                  >
                    Marked senders
                  </Button>
                  <Button color="danger" outline onClick={() => setShowBulkPanel(!showBulkPanel)}>
                    <i className="bx bx-edit-alt align-middle me-1"></i> Bulk Update
                  </Button>
                  <Button 
                    color="danger" 
                    onClick={handleAddRow}
                  >
                    Add Row
                  </Button>
                  <Button 
                    color="danger" 
                    onClick={handleSaveChanges} 
                    disabled={Object.keys(editedRows).length === 0 && !isHighlightsChanged}
                  >
                    Save Changes
                  </Button>
                </>
              )}
            </>
          )}
        </div>
      </div>

      {/* Bulk Update Panel */}
      {showBulkPanel && (
        <Card className="mb-4 border shadow-sm">
          <CardBody>
            <h5 className="card-title mb-3">Bulk Update Records</h5>
            <Row className="align-items-end g-3">
              <Col md={3}>
                <FormGroup className="mb-0">
                  <Label>Select Column</Label>
                  <Input type="select" value={bulkField} onChange={(e) => {
                    setBulkField(e.target.value);
                    handleClearSearch();
                  }}>
                    <option value="enterprise">Enterprise</option>
                    <option value="is_delivered">Is Delivered</option>
                    <option value="enterprise_recognizable">Recognizable</option>
                    <option value="smsc_owner">SMSC Owner</option>
                    <option value="country">Country</option>
                    <option value="operator">Operator</option>
                    <option value="receiver">Receiver</option>
                    <option value="smsc_date">SMSC Date</option>
                    <option value="sender_recieved">Sender Received</option>
                    <option value="recieved_text">Received Text</option>
                    <option value="smsc">SMSC</option>
                    <option value="expected_sms">Expected SMSC</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="mb-0">
                  <Label>Find Value</Label>
                  <Input 
                    type="text" 
                    placeholder="Enter exact value to find" 
                    value={bulkFind} 
                    onChange={(e) => setBulkFind(e.target.value)} 
                    disabled={searchResults !== null}
                  />
                </FormGroup>
              </Col>
              <Col md={2}>
                {searchResults === null ? (
                  <Button color="danger" className="w-100" onClick={handleSearchBulk} disabled={bulkFind !== "" && bulkFind.length < 3}>
                    <i className="bx bx-search-alt me-1"></i> Search
                  </Button>
                ) : (
                  <Button color="danger" outline className="w-100" onClick={handleClearSearch}>
                    <i className="bx bx-x me-1"></i> Clear Search
                  </Button>
                )}
              </Col>
            </Row>

            {searchResults !== null && (
              <Row className="align-items-end g-3 mt-2 pt-3 border-top">
                <Col md={12}>
                  <div className="mb-2">
                    <Badge color="success" className="font-size-13 p-2">
                      {searchResults.length} matching records found
                    </Badge>
                  </div>
                </Col>
                <Col md={4}>
                  <FormGroup className="mb-0">
                    <Label>Replace With</Label>
                    <Input 
                      type="text" 
                      placeholder="Enter new value" 
                      value={bulkReplace} 
                      onChange={(e) => setBulkReplace(e.target.value)} 
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <Button 
                    color="danger" 
                    className="w-100 fw-bold" 
                    onClick={handleBulkUpdate} 
                    disabled={searchResults.length === 0 || bulkReplace === undefined || bulkReplace === null}
                  >
                    <i className="bx bx-check-double me-1"></i> Bulk Update
                  </Button>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>
      )}

      <BootstrapTable
        key={showHiddenColumns ? "visible" : "hidden"}
        keyField="uid"
        data={searchResults !== null ? searchResults : data}
        columns={visibleColumns}
        defaultSorted={[{ dataField: 'smsc_date', order: 'asc' }]}
        defaultSortDirection="asc"
        cellEdit={(isOldReport || ![2, 3, 5].includes(role)) ? undefined : cellEdit}
        filter={filterFactory()}
        classes="table table-bordered table-hover"
        wrapperClasses="table-responsive"
      />

      {/* Customer Reassignment Modal */}
      <Modal isOpen={showReassignModal} toggle={() => setShowReassignModal(!showReassignModal)} centered>
        <ModalHeader toggle={() => setShowReassignModal(!showReassignModal)}>Customer Reassignment</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Current Customer</Label>
                <Input type="text" value={currentCustomerName} disabled />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>New Customer</Label>
                <Select
                  value={newCustomer}
                  onChange={(selectedOption) => setNewCustomer(selectedOption)}
                  options={customers}
                  placeholder="Select customer..."
                  isClearable
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" outline onClick={() => setShowReassignModal(false)}>Cancel</Button>
          <Button color="danger" onClick={handleReassignCustomer} disabled={!newCustomer}>Reassign</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default EnptReportDataGrid;
